import React, { Component, } from 'react'
import PropTypes from 'prop-types'
import { NOT_FOUND, } from 'redux-first-router'
import { LOCATION_VIEW_ALL_TRIPS, LOCATION_HOME, } from 'redux/actions/actionTypes'

import Four0FourScene from './Scenes/Four0FourScene'
import TripScene from './Scenes/TripScene'
import TripListingScene from './Scenes/TripListingScene'
import TripsListScene from './Scenes/TripsListScene'

import MagicMenu from 'components/MagicMenu'
import MagicDrawer from 'components/MagicDrawer'
import ShareTrip from 'components/ShareTrip'
import ShareButton from 'components/ShareButton'
import { renderAppHelmet, } from 'lib/pageHelmet'

class SceneManager extends Component {
  static propTypes = {
    appMode: PropTypes.string.isRequired,
    location: PropTypes.shape({
      type: PropTypes.string,
    }).isRequired,
    selectedTripId: PropTypes.string,
    selectedEventId: PropTypes.string,
    selectedEventInfoDisplayed: PropTypes.bool,
    actions: PropTypes.shape({
      navViewAllTrips: PropTypes.func.isRequired,
      navAddTrip: PropTypes.func.isRequired,
      navEditTrip: PropTypes.func.isRequired,
      navViewTripAsMap: PropTypes.func.isRequired,
      navViewTripAsList: PropTypes.func.isRequired,
    }).isRequired,
    existingTripIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  }

  static defaultProps = {
    selectedTripId: undefined,
    selectedEventId: undefined,
    selectedEventInfoDisplayed: false,
  }
  render() {
    const {
      appMode,
      location,
      existingTripIds,
      actions,
      selectedTripId,
      listingMode,
      addingTrip,
      editingTrip,
      selectedEventId,
    } = this.props
    let MainDisplay
    if (location.type === NOT_FOUND) {
      // no such location found
      return <Four0FourScene />
    }
    if (
      // tripId param is present but has no matching trip
      location.payload &&
      location.payload.tripId &&
      existingTripIds.indexOf(location.payload.tripId) < 0
    ) {
      // TODO: show a specific trip not found scene
      return <Four0FourScene />
    }

    // HACK FOR NOW TO DEFAULT THE TRIP LIST
    const isViewingTripsList = (appMode !== 'default-trip-only' && (location.type === LOCATION_HOME || location.type === LOCATION_VIEW_ALL_TRIPS))
    if (isViewingTripsList) {
      MainDisplay = <TripsListScene />
    } else if (listingMode) {
      MainDisplay = <TripListingScene />
    } else {
      MainDisplay = <TripScene />
    }

    const menuOptions = []
    if (appMode !== 'default-trip-only') {
      menuOptions.push({
        label: 'Add New Trip',
        action: actions.navAddTrip,
      })
      menuOptions.push({
        label: 'Edit This Trip',
        action: () => {
          actions.navEditTrip({ tripId: selectedTripId, })
        },
      })
      menuOptions.push({
        label: 'All Trips',
        action: () => {
          actions.navViewAllTrips()
        },
      })
    }

    let discreetMode = false
    if (listingMode) {
      menuOptions.push({
        label: 'Map View',
        action: () => {
          actions.navViewTripAsMap({ tripId: selectedTripId, })
        },
      })
      discreetMode = true
    } else {
      menuOptions.push({
        label: 'List View',
        action: () => {
          actions.navViewTripAsList({ tripId: selectedTripId, })
        },
      })
    }

    return (
      <div>
        {renderAppHelmet()}
        {MainDisplay}
        {!addingTrip && !editingTrip && !selectedEventId && !isViewingTripsList && <MagicMenu menuOptions={menuOptions} discreet={discreetMode} />}
        {!addingTrip && !editingTrip && !selectedEventId && !isViewingTripsList && (
          <ShareButton />
        )}
        <MagicDrawer>
          <ShareTrip />
        </MagicDrawer>
      </div>
    )
  }
}

export default SceneManager



// WEBPACK FOOTER //
// ./src/components/_sceneManager/component.js